// extracted by mini-css-extract-plugin
module.exports = {"clinic-card-container":"DoctorClinicCard_clinic-card-container__37G36","content":"DoctorClinicCard_content__39E9j"};